import React from 'react';
import ResetPassword from '../features/auth/components/ResetPassword';

const ResetPasswordPage = () => {
  return <ResetPassword />;
};

export default ResetPasswordPage;
